import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Checkbox from '@material-ui/core/Checkbox'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import { AppButton } from '../../Components'
import { Box, Chip } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 'auto',
  },
  paper: {
    width: 250,
    overflow: 'auto'
  },
  rightPaper: {
    height: 500,
  },
  leftPaper: {
    height: 235,
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
  buttonContainer: {
    margin: '0 10px',
    display: 'flex'
  },
  resetButtonContainer: {
    width: '100%',
    justifyContent: 'center'
  },
  formButton: {
    minWidth: 120,
    margin: '10px',
  },
  white: {
    color: 'white',
  },
  headings: {
    color: '#6F6F6F',
    fontSize: '12px',
    display: 'flex',
    justifyContent: 'center',
    margin: 8
  },
  break: {
    flexBasis: '100%',
    height: 0
  },
  reset: {
    fontSize: '12px',
    cursor: 'pointer',
    color: '#F37320'
  },
  errorMessage: {
    color: 'red',
    fontSize: '12px'
  }
}))

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1)
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1)
}

function TableColumns(props) {
  const classes = useStyles()
  const [checked, setChecked] = React.useState([])
  const [all, setAll] = React.useState([
    'SITE ID', 'SYSTEM NAME', 'BATTERY CAPACITY (kWh)', 'BATTERY POWER (kW)', 'COMMITTED POWER (kW)', 'LOCATION', 'STATUS', 'STATE', 'CITY', 'ZIP/POSTAL CODE'
  ])
  const [left, setLeft] = React.useState([])
  const [right, setRight] = React.useState([])
  const [leftLower, setLeftLower] = React.useState([])
  const [disableButton, setDisableButton] = React.useState(false)

  const leftChecked = intersection(checked, left)
  const leftLowerChecked = intersection(checked, leftLower)
  const rightChecked = intersection(checked, right)

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value)
    const newChecked = [...checked]

    if (currentIndex === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(currentIndex, 1)
    }

    setChecked(newChecked)
  }

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked, leftLowerChecked))
    setLeft(not(left, leftChecked))
    setLeftLower(not(leftLower, leftLowerChecked))
    setChecked(not(checked, [...leftChecked, ...leftLowerChecked]))
    // setChecked(not(checked, leftLowerChecked))
  }

  const handleCheckedLeft = () => {
    let leftItem = [], leftLowerItem = []
    rightChecked.forEach((rcheck, i) => {
      if (rcheck.tag) {
        leftLowerItem.push(rcheck)
      } else {
        leftItem.push(rcheck)
      }
    })
    setLeft(left.concat(leftItem))
    setLeftLower(leftLower.concat(leftLowerItem))
    setRight(not(right, rightChecked))
    setChecked(not(checked, rightChecked))
  }

  const setLeftRight = () => {
    setRight(props.headings)
    const left = all.filter(({ header: header1 }) => !props.headings.some(({ header: header2 }) => header2 === header1))
    const leftLower = left.filter((item, i) => item.tag)
    const leftUpper = left.filter((item, i) => !item.tag)
    setLeft(leftUpper)
    setLeftLower(leftLower)
  }

  const setItems = () => {
    Object.keys(props.columns).forEach(key => {
      if (key === 'columns_to_be_shown') {
        let right = []
        props.columns[key].forEach(column => {
          right.push({ id: column.toLowerCase(), header: column, tag: all.includes(column) ? false : true })
        })
        setRight(right)
      } else if (key === 'system_defined_fields') {
        let left = []
        props.columns[key].forEach(column => {
          left.push({ id: column.toLowerCase(), header: column })
        })
        setLeft(left)
      } else {
        let leftLower = []
        props.columns[key].forEach(column => {
          leftLower.push({ id: column.toLowerCase(), header: column, tag: true })
        })
        setLeftLower(leftLower)
      }
    })
  }

  useEffect(() => {
    if (right && right.length <= 0) {
      setDisableButton(true)
    } else {
      setDisableButton(false)
    }
  }, [right])

  useEffect(() => {
    //setLeftRight()
    setItems()
  }, [props.column])

  const customList = (items, side) => (
    <>
      <div className={classes.headings}>{side === 'leftUpper' ? 'System Defined Fields' : side === 'leftLower' ? 'Tags' : 'Columns to be shown'}</div>
      <Paper className={`${classes.paper} ${side === 'right' ? classes.rightPaper : classes.leftPaper}`}>
        <List dense component="div" role="list">
          {items.map((value) => {
            const labelId = `transfer-list-item-${value}-label`
            return (
              <ListItem key={value} role="listitem" button onClick={handleToggle(value)}>
                <ListItemIcon>
                  <Checkbox
                    checked={checked.indexOf(value) !== -1}
                    tabIndex={-1}
                    disableRipple
                    color="primary"
                    inputProps={{ 'aria-labelledby': labelId }}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={value.header} />
                {side === 'right' && value.tag && <Chip variant="outlined" color="primary" label="TAG" size="small" />}
              </ListItem>
            )
          })}
          <ListItem />
        </List>
      </Paper>
    </>
  )

  return (
    <Grid container spacing={2} justify="center" alignItems="center" className={classes.root}>
      <Grid item>
        <Grid container direction="column" alignItems="center">
          <Grid item >{customList(left, 'leftUpper')}</Grid>
          <Grid item >{customList(leftLower, 'leftLower')}</Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container direction="column" alignItems="center">
          <Button
            variant="outlined"
            size="small"
            className={classes.button}
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0 && leftLowerChecked.length === 0}
            aria-label="move selected right"
          >
            &gt;
          </Button>
          <Button
            variant="outlined"
            size="small"
            className={classes.button}
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            aria-label="move selected left"
          >
            &lt;
          </Button>
        </Grid>
      </Grid>
      <Grid item>{customList(right, 'right')}</Grid>
      <div className={`${classes.buttonContainer} ${classes.resetButtonContainer}`} color="primary">
        <span className={classes.reset} onClick={() => { props.resetDefault(); props.handleClose() }}>Reset Default</span>
      </div>
      <div className={classes.break}></div>
      {disableButton &&
        <>
          <Box className={classes.errorMessage}>Select atleast one column</Box>
          <div className={classes.break}></div>
        </>
      }
      <div className={classes.buttonContainer}>
        <AppButton className={`${classes.formButton} ${classes.white}`} disabled={disableButton} text="Save" onClick={() => { props.handleRows(right); props.handleClose() }} />
        <AppButton className={classes.formButton} text="Cancel" fill={false} onClick={props.handleClose} />
      </div>
    </Grid >
  )
}

export default TableColumns